var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'loading-container': true, 'loading': _vm.isLoading, 'visible': _vm.isVisible},attrs:{"id":"progress-bar"}},[_c('div',{staticClass:"loader",style:({ width: _vm.progress + '%' })},[_c('div',{staticClass:"light"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-598f2a93","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/components/ProgressBar.vue
// module id = null
// module chunks = 